// R6-4 — THE SPELLBOOK'S OWN CONTENTS, MOVED VERBATIM OUT OF App.tsx.
//
// This list is the browse ladder the member sees on the Magic Room's contents page, and every entry
// is a category the SERVER agrees to browse (`SPELL_BROWSE_CATEGORIES`). A category listed here that
// the server does not browse renders a heading with nothing under it; a category the CATALOG uses
// that is missing here is one of her own recipes with no door to it at all.
// `scripts/r6-catalogs.mjs` and `scripts/t7-catalog.mjs` both hold this to the server and to her sheet.
//
// This module imports NOTHING, which is the entry requirement for the gate's loader.

// T7-1: "self" and "success" carry her catalog recipes whose purpose fits nowhere else (Bella,
// Esteem, Willpower / Fame, Power). Browse-only, matching SPELL_BROWSE_CATEGORIES on the server.
export const SPELLBOOK_CATEGORIES = ["love", "money", "protection", "cleansing", "healing", "luck", "reversal", "justice", "peace", "guidance", "self", "success"];
